import { FirestoreDataConverter } from "firebase/firestore"
import { GroupDocument } from "../index"

export default {
    toFirestore: (group: GroupDocument) => ({
        name: group.name,
        organisation: group.organisation,
        modules: group.modules,
    }),
    fromFirestore: (snapshot, options) => {
        const group = snapshot.data(options)
        return {
            id: snapshot.id,
            name: group.name,
            organisation: group.organisation,
            modules: group.modules,
        }
    },
} as FirestoreDataConverter<GroupDocument>
